module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"首页":"Home"}}')
  delete Component.options._Ctor
}
